import React from "react";
import withIntl from "../../utils/withIntl";
import { Chip, Grid, IconButton, Typography } from "@material-ui/core";
import GetCurrency from "../../helper/GetCurrency";

function Article(props) {
  return (
    <div
      {...props}
      style={{ paddingLeft: "32px", color: props.article.active && props.article.manual_active ? "black" : "grey" }}
      ref={props.innerRef}
    >
      <Grid container spacing={1}>
        <Grid item xs={6} style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
          <div style={{ display: "flex", alignItems: "center" }} onClick={props.handleClick}>
            <Typography>{props.article.name}</Typography>
            {props.article.weight != null ? <Chip size={"small"} label={"AYCE " + props.article.weight} /> : null}
            {props.article.getPrintTags().map((printTag) => {
              return <Chip size={"small"} label={printTag} />;
            })}
          </div>
        </Grid>
        <Grid item xs={3} style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
          <Typography style={{ textAlign: "right" }}>
            {GetCurrency() + " " + (props.article.price / 100).toFixed(2)}
          </Typography>
        </Grid>
        <Grid item xs={2}>
          {props.showActionButton && (
            <IconButton
              onClick={() => {
                props.onAction();
              }}
            >
              {props.actionIcon}
            </IconButton>
          )}
        </Grid>
      </Grid>
    </div>
  );
}

export default withIntl(Article);
